import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  totals: {
    t_so_luong: number;
    t_khoi_luong: number;
    t_tien_nt2: number;
    t_thue_nt: number;
    t_km_nt: number;
    t_tc_tien_nt2: number;
    t_ck_nt: number;
    t_tt_nt: number;
  };
  state: FormFieldState;
}

export function BottomBar({ totals }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-3 py-1.5 xl:px-4 xl:py-2'>
      <div className='grid grid-cols-2 gap-x-4 gap-y-1 xl:grid-cols-4 xl:gap-x-5 xl:gap-y-0'>
        <div className='min-w-0'>
          <div className='flex items-center'>
            <Label className='w-[92px] text-[13px] font-medium xl:w-28'>Tổng số lượng</Label>
            <div className='min-w-0 flex-1 pb-0.5'>
              <FormFieldV2 name='t_so_luong' type='text' disabled value={formatRoundedNumber(totals.t_so_luong, 6)} />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-[92px] text-[13px] font-medium xl:w-28'>Tổng khối lượng</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2
                name='t_khoi_luong'
                type='text'
                disabled
                value={formatRoundedNumber(totals.t_khoi_luong, 6)}
              />
            </div>
          </div>
        </div>

        <div className='min-w-0'>
          <div className='flex items-center'>
            <Label className='w-[82px] text-[13px] font-medium xl:w-24'>Tổng tiền</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2
                name='t_tien_nt2'
                type='text'
                className='w-full'
                value={formatRoundedNumber(totals.t_tien_nt2)}
              />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-[82px] text-[13px] font-medium xl:w-24'>Tổng thuế</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2
                name='t_thue_nt'
                type='text'
                className='w-full'
                value={formatRoundedNumber(totals.t_thue_nt)}
              />
            </div>
          </div>
        </div>

        <div className='min-w-0'>
          <div className='flex items-center'>
            <Label className='w-[96px] text-[13px] font-medium xl:w-[122px]'>Tổng tiền KM</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2 name='t_km_nt' type='text' className='w-full' value={formatRoundedNumber(totals.t_km_nt)} />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-[96px] text-[13px] font-medium xl:w-[122px]'>Tổng chiết khấu</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2 name='t_ck_nt' type='text' className='w-full' value={formatRoundedNumber(totals.t_ck_nt)} />
            </div>
          </div>
        </div>

        <div className='min-w-0'>
          <div className='flex items-center'>
            <Label className='w-[96px] text-[13px] font-medium xl:w-[122px]'>Tổng tiền hàng</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2
                name='t_tc_tien_nt2'
                type='text'
                className='w-full'
                value={formatRoundedNumber(totals.t_tc_tien_nt2)}
              />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-[96px] text-[13px] font-medium xl:w-[122px]'>Tổng thanh toán</Label>
            <div className='min-w-0 flex-1'>
              <FormFieldV2 name='t_tt_nt' type='text' className='w-full' value={formatRoundedNumber(totals.t_tt_nt)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
